module.exports = __webpack_public_path__ + "media/images/players/STENSON_HENRIK-a6674e1748b31d0c46f475e2f855445a.png";